module.exports = __webpack_public_path__ + "assets/img/error.fcee3a1d.png";